// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fai-filters-wrapper[data-v-0a990d9e] {\n  padding: 0 30px 15px;\n}\n", ""]);
// Exports
module.exports = exports;
